import { createAsyncThunk } from '@reduxjs/toolkit';

import { ShopType } from '@app/entities/Shop';
import { RootState } from '@app/redux/store';
import { ServiceWidget } from '@app/services/ServiceWidget';
import { fetchShopsDto } from './api.dto';
import { endpoints } from '@features/productAvailabilityInTheStores';
import { isWithYellowSlots } from '@entities/infoMessages/ui/YellowSlots/IsWithYellowSlots';

export const fetchShops = createAsyncThunk<ShopType[], fetchShopsDto>(
  'fastOrder/fetchShops',
  async ({ productRN, part, regionId, price }, thunkAPI) => {
    const RegionShops = (thunkAPI.getState() as RootState).header.data.shopsList;
    const historyRnProduct = (thunkAPI.getState() as RootState).fastOrder.historyRnProduct;
    const historyShops = (thunkAPI.getState() as RootState).fastOrder.historyShops;
    if (historyRnProduct === productRN) {
      return [...historyShops];
    }

    const { data: response, isError } = await thunkAPI.dispatch(endpoints.getProductAllAvailability.initiate({ productRN, regionId, part }));
    if (isError) {
      return [];
    }

    const requiredTopLevelFields: Array<keyof Partial<ShopType>> = [
      'shopId',
      'address',
      'map',
      'url',
      'name',
      'type',
      'phone',
      'quantityNoToday',
      'quantityToday',
      'statusDeliveryNoToday',
      'statusDeliveryToday',
    ];
    const requiredNestedFields: Array<keyof Partial<ShopType['map']>> = ['x', 'y', 'zoom'];

    const arrayShops = response?.pickUpAllShops
      .filter(
        shop =>
          requiredTopLevelFields.every(field => shop[field] !== undefined && shop[field] !== null) &&
          requiredNestedFields.every(field => shop.map?.[field] !== undefined && shop.map?.[field] !== null),
      )
      .map(shop => {
        const shopInfo = RegionShops.find(x => x.id === shop.shopId);
        return {
          ...shop,
          map: shopInfo?.map,
          yandexRating: shopInfo?.yandexRating,
          yandexAmountView: shopInfo?.yandexAmountView,
          yandexReviews: shopInfo?.yandexReviews,
        };
      });

    if (arrayShops) {
      const widgetData = await ServiceWidget.getRecordShm(
        arrayShops.map(x => x.shopId),
        isWithYellowSlots(price, regionId),
      );
      if (widgetData) {
        return arrayShops.map(shop => {
          return {
            ...shop,
            record: widgetData.find(x => x.shopId === shop.shopId)?.record,
          };
        });
      } else {
        return arrayShops.map(shop => {
          return {
            ...shop,
            record: false,
          };
        });
      }
    }
  },
);
